/**
 * Lädt die tatsächlichen Ordner einer Akte samt Vorlagen für die Ordnerwahl
 * beim Ablegen von E-Mail-Anhängen (Kundenfeedback 18.10.2026, XX). Geladen
 * wird erst, wenn caseId() einen Wert liefert (Dialog offen).
 */
import { computed, ref, watch } from 'vue'
import { folderGroups, type FolderTargets, pickDefaultFolder } from './caseFolders'
import { loadFolderTargets } from './emailFilingApi'

export function useFolderTargets (caseId: () => number | null) {
  const targets = ref<FolderTargets | null>(null)
  const loading = ref(false)
  const error = ref('')
  let token = 0

  async function load (id: number | null) {
    const current = ++token
    error.value = ''
    // Ordner der vorherigen Akte sofort verwerfen – sonst könnten sie während
    // des Ladens an die neue Akte geschickt werden.
    targets.value = null
    if (!id) {
      loading.value = false
      return
    }
    loading.value = true
    try {
      const next = await loadFolderTargets(id)
      if (current === token) targets.value = next
    } catch (error_) {
      if (current === token) error.value = (error_ as Error).message
    } finally {
      if (current === token) loading.value = false
    }
  }

  watch(caseId, id => load(id), { immediate: true })

  const groups = computed(() => (targets.value ? folderGroups(targets.value) : []))
  const defaultFolder = computed(() => (targets.value ? pickDefaultFolder(targets.value) : ''))

  return { targets, loading, error, groups, defaultFolder, reload: () => load(caseId()) }
}
